import React, {Component} from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import ThemeButton from './Element/ThemeButton/ThemeButton';

import Homepage from './Pages/Homepage1';
import Aboutus from './Pages/Aboutus/Aboutus';
import Error403 from './Pages/Error/Error403';
import Error404 from './Pages/Error/Error404';
import Error405 from './Pages/Error/Error405';
import ComingSoon1 from './Pages/ComingSoon/ComingSoon1';
import UnderMaintenance from './Pages/UnderMaintenance';
import Expertise from './Pages/Expertise';
import ProjectManagement from './Pages/ProjectManagement';
import OurProjects from './Pages/OurProjects';
import ProjectDetails from './Pages/ProjectDetails';
import Team from './Pages/Team';
import Faqs from './Pages/Faqs';
import Login from './Pages/Login';
import Register from './Pages/Register';
import Contact from './Pages/Contact';
import Service from './Pages/Service/Service';
// import ServicesDetails from './Pages/Service/ServicesDetails';
import MessagingSolutions from './Pages/Service/MessagingSolutions';
import SMPP_Platform from './Pages/Service/SMPP_Platform';
import EmailSolutions from './Pages/Service/EmailSolutions';
import MobileAppDev from './Pages/Service/MobileAppDev';
import VoiceSolutions from './Pages/Service/VoiceSolutions';
import WebDevelopment from './Pages/Service/WebDevelopment';
import WhatsAppApi from './Pages/Service/WhatsAppApi';

// import ShopColumns from './Pages/Shop/ShopColumns';
// import ShopColumnsSidebar from './Pages/Shop/ShopColumnsSidebar';

// import ShopCart from './Pages/Shop/ShopCart';
// import ShopCheckout from './Pages/Shop/ShopCheckout';	
// import ShopProductDetails from './Pages/Shop/ShopProductDetails';	

// import ShopWishlist from './Pages/Shop/ShopWishlist';
// import ShopLogin from './Pages/Shop/ShopLogin';
// import ShopRegister from './Pages/Shop/ShopRegister';

// import ShortIconBox from './Pages/ShortCode/ShortIconBox';
// import ShortCounter from './Pages/ShortCode/ShortCounter';
// import ShortPortfolio from './Pages/ShortCode/ShortPortfolio';
// import ShortTabs from './Pages/ShortCode/ShortTabs';
// import ShortTeam from './Pages/ShortCode/ShortTeam';
// import ShortTestimonial from './Pages/ShortCode/ShortTestimonial';
// import ShortForm from './Pages/ShortCode/ShortForm';
// import ShortAccordions from './Pages/ShortCode/ShortAccordions';

import ScrollToTop from './Element/ScrollToTop';

class Markup extends Component{
	render(){
		return(
			// <BrowserRouter basename="/react/demo">
            <BrowserRouter basename={process.env.PUBLIC_URL}>
                <div className="page-wraper">
                    <Switch>
                        <Route path='/' exact component={Homepage} />
                        <Route path='/aboutus' exact component={Aboutus} />
                        <Route path='/error-403' exact component={Error403} />
                        <Route path='/error-404' exact component={Error404} />
                        <Route path='/error-405' exact component={Error405} />
                        <Route path='/coming-soon-1' exact component={ComingSoon1} />
                        <Route path='/under-maintenance' exact component={UnderMaintenance} />
                        <Route path='/expertise' exact component={Expertise} />
                        <Route path='/project-management' exact component={ProjectManagement} />
                        <Route path='/our-projects' exact component={OurProjects} />
                        <Route path='/project-details' exact component={ProjectDetails} />
                        <Route path='/team' exact component={Team} />
                        <Route path='/faqs' exact component={Faqs} />
                        <Route path='/login' exact component={Login} />
                        <Route path='/register' exact component={Register} />
                        <Route path='/contact' exact component={Contact} />
                        <Route path='/services' exact component={Service} />
                        <Route path='/messaging-solutions' exact component={MessagingSolutions} />
                        <Route path='/smpp-platform' exact component={SMPP_Platform} />
                        <Route path='/email-solutions' exact component={EmailSolutions} />
                        <Route path='/mobile-app' exact component={MobileAppDev} />
                        <Route path='/voice-solutions' exact component={VoiceSolutions} />
                        <Route path='/web-development' exact component={WebDevelopment} />
                        <Route path='/whatsapp-business' exact component={WhatsAppApi} />
                        
                        {/* <Route path='/shop-columns' exact component={ShopColumns} />
                        <Route path='/shop-columns-sidebar' exact component={ShopColumnsSidebar} />
						
                        <Route path='/shop-cart' exact component={ShopCart} />
                        <Route path='/shop-checkout' exact component={ShopCheckout} />
                        <Route path='/shop-product-details' exact component={ShopProductDetails} />
                        <Route path='/shop-wishlist' exact component={ShopWishlist} />
                        <Route path='/shop-login' exact component={ShopLogin} />
                        <Route path='/shop-register' exact component={ShopRegister} /> */}
						
                        {/* <Route path='/short-icon-box' exact component={ShortIconBox} />
                        <Route path='/short-counter' exact component={ShortCounter} />
                        <Route path='/short-portfolio' exact component={ShortPortfolio} />
                        <Route path='/short-tabs' exact component={ShortTabs} />
                        <Route path='/short-team' exact component={ShortTeam} />
                        <Route path='/short-testimonial' exact component={ShortTestimonial} />
                        <Route path='/short-form' exact component={ShortForm} />
                        <Route path='/short-accordions' exact component={ShortAccordions} />						 */}
					</Switch>
                </div>
				<ScrollToTop />
				<ThemeButton />
            </BrowserRouter>	
		)
	}
	
}

export default Markup;